import type { IHeatmapLoadingMap, IHeatmapLoadingStore } from '../../stores';

import { createViewContextHook } from '@gem-sdk/heatmap-react';
import { useHeatmapLoadingStore } from '../../stores';
import { EHeatmapLoadingKey } from '../../types';

interface IHeatmapLoadingState {
  loadingMap?: IHeatmapLoadingMap;
  getLoadingByKey: (key: EHeatmapLoadingKey) => boolean;
}

interface IHeatmapLoadingActions {
  setLoadingByKey: (key: EHeatmapLoadingKey, isLoading: boolean) => void;
  clearView: (viewId: string) => void;
}

export const useHeatmapLoadingContext = createViewContextHook<
  IHeatmapLoadingStore,
  IHeatmapLoadingState,
  IHeatmapLoadingActions
>({
  useStore: useHeatmapLoadingStore,

  getState: (store, viewId) => ({
    loadingMap: store.loadingMap.get(viewId),
    getLoadingByKey: (key) => {
      const isLoadingAuth = store.getLoadingByKey(EHeatmapLoadingKey.AUTH, viewId) || false;
      if (isLoadingAuth) return true;

      return store.loadingMap.get(viewId)?.get(key) ?? true;
    },
  }),

  getActions: (store, viewId) => ({
    setLoadingByKey: (key, isLoading) => store.setLoadingByKey(key, isLoading, viewId),
    clearView: (viewId) => store.clearView(viewId),
  }),
});
